// - Wenn in Partials gearbeitet werden soll, dann benutzt folgenden Schnippsel:
//  import './NAME-DER-DATEI';

$(document).ready(function() {

    function cookieBannerLvl3(){
        function selectLvl3(close) {
            $("input[name=acceptanceLevelChoice][value='3']").prop('checked', true);
            close();
        }
        $(".cookie-banner__button--level3").click(function (){
            selectLvl3(function (){
                $(".cookie-banner__close").click();
            });
        });
    }
    cookieBannerLvl3();
});
